// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2G9vj","file":"styles_file__f9pIq"};